import api from './api';

const eventService = {
  // Get centers by country - uses EventChannel API
  getCenters: async (countryDesc = 'USA') => {
    try {
      const response = await api.get(`/EventChannel/GetCentersByCountry?countryDesc=${countryDesc}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching centers:', error);
      throw error;
    }
  },

  // Get all events by center and organization
  getEventsByCenter: async (centerId, organizationId = null) => {
    const response = await api.post('/EventChannel/GetEventsByCenterAndOrg', { 
      centerId: centerId, 
      organizationId: organizationId 
    });
    return response.data;
  },

  // Get event details
  getEventDetails: async (eventId) => {
    const response = await api.post('/EventChannel/GetEventDetails', { Event_Id: eventId });
    return response.data;
  },

  // Get event services (seva options)
  getEventServices: async (eventId) => {
    const response = await api.post('/EventChannel/GetEventServices', { Event_Id: eventId });
    return response.data;
  },

  // Get event time options
  getEventTimeOptions: async (eventId) => {
    const response = await api.post('/EventChannel/GetEventTimeOptions', { Event_Id: eventId });
    return response.data;
  },

  // Get optional services
  getOptionalServices: async (eventId) => {
    const response = await api.post('/EventChannel/GetOptionalServices', { Event_Id: eventId });
    return response.data;
  },

  // Get event highlights
  getEventHighlights: async (eventId) => {
    const response = await api.post('/EventChannel/GetEventHighlights', { event_Id: eventId });
    return response.data;
  },

  // Get event coordinators
  getEventCoordinators: async (eventId) => {
    const response = await api.post('/EventChannel/GetEventCoordinators', { event_Id: eventId });
    return response.data;
  },

  // Get complete event details (all data in one call)
  getCompleteEventDetails: async (eventId) => {
    const response = await api.post('/EventChannel/GetCompleteEventDetails', { event_Id: eventId });
    return response.data;
  },

  // Create event registration
  createRegistration: async (registrationData) => {
    const response = await api.post('/EventChannel/CreateEventRegistration', registrationData);
    return response.data;
  },

  // Add family members
  addFamilyMembers: async (registrationId, familyMembers) => {
    const response = await api.post('/EventChannel/AddFamilyMembers', {
      registrationId,
      familyMembers,
    });
    return response.data;
  },

  // Process payment
  processPayment: async (paymentData) => {
    const response = await api.post('/EventChannel/ProcessPayment', paymentData);
    return response.data;
  },

  // Send confirmation email
  sendConfirmationEmail: async (emailData) => {
    const response = await api.post('/EventChannel/SendConfirmationEmail', emailData);
    return response.data;
  },

  // Get registration by ID
  getRegistrationById: async (registrationId) => {
    const response = await api.post('/EventChannel/GetRegistrationById', { registrationId });
    return response.data;
  },

  // Get user registrations
  getUserRegistrations: async (email) => {
    const response = await api.post('/EventChannel/GetUserRegistrations', { email });
    return response.data;
  },

  // New Student Registration APIs
  
  // Get all students for a user
  getStudents: async (userId) => {
    try {
      const response = await api.get(`/EventChannel/GetStudents?userId=${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching students:', error);
      throw error;
    }
  },

  // Get registered students for an event
  getRegisteredStudents: async (userId, eventId) => {
    try {
      const response = await api.get(`/EventChannel/GetRegisteredStudents?userId=${userId}&eventId=${eventId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching registered students:', error);
      throw error;
    }
  },

  // Add a new student
  addStudent: async (studentData) => {
    const payload = {
      userId: studentData.userId,
      eventId: studentData.eventId,
      firstName: studentData.firstName,
      lastName: studentData.lastName,
      gotram: studentData.gotram || '',
      nastram: studentData.nastram || '',
    };
    
    // Only include optional fields if they have valid values
    if (studentData.dateOfBirth) {
      payload.dateOfBirth = studentData.dateOfBirth;
    }
    if (studentData.gender) {
      payload.gender = studentData.gender;
    }
    if (studentData.relationship) {
      payload.relationship = studentData.relationship;
    }
    
    const response = await api.post('/EventChannel/AddStudent', payload);
    return response.data;
  },

  // Update an existing student
  updateStudent: async (studentData) => {
    const payload = {
      studentId: studentData.studentId,
      userId: studentData.userId,
      eventId: studentData.eventId,
      firstName: studentData.firstName,
      lastName: studentData.lastName,
      gotram: studentData.gotram || '',
      nastram: studentData.nastram || '',
    };
    
    // Only include optional fields if they have valid values
    if (studentData.dateOfBirth) {
      payload.dateOfBirth = studentData.dateOfBirth;
    }
    if (studentData.gender) {
      payload.gender = studentData.gender;
    }
    if (studentData.relationship) {
      payload.relationship = studentData.relationship;
    }
    
    const response = await api.post('/EventChannel/UpdateStudent', payload);
    return response.data;
  },

  // Post event registration (order)
  postEventRegistration: async (orderData) => {
    try {
      const response = await api.post('/EventChannel/PostEventRegistration', orderData);
      return response.data;
    } catch (error) {
      console.error('Error creating event registration:', error);
      throw error;
    }
  },

  // Post event payment
  postEventPayment: async (paymentData) => {
    try {
      const response = await api.post('/EventChannel/PostEventPayment', paymentData);
      return response.data;
    } catch (error) {
      console.error('Error creating event payment:', error);
      throw error;
    }
  },

  // Post event attendee
  postEventAttendee: async (attendeeData) => {
    try {
      const response = await api.post('/EventChannel/PostEventAttendee', attendeeData);
      return response.data;
    } catch (error) {
      console.error('Error creating event attendee:', error);
      throw error;
    }
  },

  // Post complete event enrollment with payment (transactional)
  postEventEnrollmentAndOrder: async (enrollmentData) => {
    try {
      const response = await api.post('/EventChannel/PostEventEnrollmentAndOrder', enrollmentData);
      return response.data;
    } catch (error) {
      console.error('Error processing event enrollment:', error);
      throw error;
    }
  },
};

export default eventService;
